<template>
	<div class="show-img-body">
		<div class="show-img-container">
			<div class="fx-title">
				<p>商品橱窗图设置</p>
			</div>
			<div class="img-des">图片长宽比例1:1，1M以内，格式：png/jpg/jpeg/gif 最多6张</div>
			<div class="img-des">注：1 拖动可调整显示顺序， 2 第一张图默认为橱窗图， 3 单图点击可放大预览</div>
			<div class="img-container">
				<vuedraggable class="wrapper" :options="dragOptions" v-model="showSrc" @choose="chooseImg" @end="sortImg">
					<transition-group tag="div">
						<ImgUplaod
							style="margin-left:15px"
							class="show-img"
							v-for="item in showSrc"
							:key="item.seqnum"
							:imgSrc.sync="item.newurl"
							:imgId.sync="item.id"
							:change.sync="item.change"
							:seqnum="item.seqnum"
							:uploadError.sync="item.uploadError"
							v-show="item.show"
							@updateImg="updateImg"
							@preview="preview"
							ref="showUpload"
						/>
					</transition-group>
				</vuedraggable>
			</div>
			<div class="fx-title">
				<p>商品橱窗视频设置</p>
			</div>
			<div class="img-des">商品视频最大限制20M，视频时长≤15S，支持文件类型：mp4，推荐视频比例1:1 </div>
			<div class="img-des">注：1 视频默认显示在详情页面首位， 2 视频可点击预览播放</div>
			<VideoUpload
				style="margin-left:15px"
				class="show-img"
				:videoSrc.sync="videoNewUrl"
				:videoId.sync="videoId"
				:videoModal.sync="videoModal"
				:uploadError.sync="uploadError"
				ref="videoUpload"
			/>
		</div>
		<!-- <div class="btn-box">
			<el-button type="primary" size='medium' plain @click="cancel">取消</el-button>
			<el-button type="primary" size='medium' plain @click="save">保存</el-button>
		</div> -->
		<el-dialog
			top='120px'
			title="视频预览"
			class="detail-dialog-title"
			:visible.sync="videoModal"
			width='600px'
			:close-on-click-modal="false"
			append-to-body>
			<div class="preview-video-body">
				<w-video :src="videoNewUrl" controls class="img-preview"></w-video>
			</div>
		</el-dialog>
		<el-dialog
			title="橱窗图预览"
			:visible.sync="imgModel"
			:close-on-click-modal="false"
			class="img-dialog"
			width="700px"
			append-to-body>
			<CertificateView :voucherImg="voucherImg" :initialIndex="initialIndex" v-if="imgModel" :visible.sync="imgModel"/>
		</el-dialog>
		<el-dialog
			title="商品档案图库"
			:visible.sync="galleryShow"
			:close-on-click-modal="false"
			class="img-dialog"
			width="700px"
			append-to-body>
			<div class="online-img-container">
				<p>商品图片最多只能6张，您此时只能选择<span style="color: red"> {{selectableNum}} </span>张</p>
				<div class="img-container">
					<w-image :src="item" :key="item" v-for="item in onlineImgs"></w-image>
				</div>
				<el-checkbox-group v-model="checkedImgs" :max="selectableNum">
					<el-checkbox v-for="item in onlineImgs" :key="item" :label="item" v-show="item"></el-checkbox>
				</el-checkbox-group>
				<div class="btn-box">
					<el-button type="primary" size='medium' plain @click="offlineCancel">取消</el-button>
					<el-button type="primary" size='medium' plain @click="confirm">确认</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import ImgUplaod from '@/components/dock/ImgUpload.vue'
import VideoUpload from '@/components/dock/VideoUpload.vue'
import CertificateView from '@/components/dock/CertificateView.vue'
import vuedraggable from 'vuedraggable'
export default {
	name: 'ShowImg',
	components: {
		ImgUplaod,
		VideoUpload,
		vuedraggable,
		CertificateView
	},
	props: {
		productId: String,
		goodsId: String,
		imgInfo: {
			type: Array,
			default: () => []
		},
		videoInfo: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		imgInfo (val) {
			this.getInfo()
		}
	},
	data () {
		return {
			showSrc: [
				{ defaultflag: 1, seqnum: '1', oldurl: '', newurl: '', id: '0', uploadError: false, show: true },
				{ defaultflag: 0, seqnum: '2', oldurl: '', newurl: '', id: '0', uploadError: false, show: false },
				{ defaultflag: 0, seqnum: '3', oldurl: '', newurl: '', id: '0', uploadError: false, show: false },
				{ defaultflag: 0, seqnum: '4', oldurl: '', newurl: '', id: '0', uploadError: false, show: false },
				{ defaultflag: 0, seqnum: '5', oldurl: '', newurl: '', id: '0', uploadError: false, show: false },
				{ defaultflag: 0, seqnum: '6', oldurl: '', newurl: '', id: '0', uploadError: false, show: false }
			],
			oldShowSrc: [],
			uploadError: false,
			videoOldUrl: '',
			videoNewUrl: '',
			videoId: '0',
			videoModal: false,
			imgModel: false,
			initialIndex: 0,
			voucherImg: [],
			dragDisabled: false,
			sortFlag: false,
			saveFlag: true,
			galleryShow: false,
			selectableNum: 6,
			checkedImgs: [],
			onlineImgs: []
		}
	},
	computed: {
		dragOptions () {
			if (this.dragDisabled) {
				return {
					disabled: true
				}
			} else {
				return {
					disabled: false
				}
			}
		}
	},
	created () {
		// this.getInfo()
	},
	methods: {
		offlineCancel () {
			this.galleryShow = false
		},
		confirm () {
			this.selectableNum = this.selectableNum - this.checkedImgs.length
			if (this.checkedImgs.length < 1) {
				this.galleryShow = false
				return false
			}
			let emptyImgs = this.showSrc.filter(item => {
				return item.newurl === ''
			})
			for (let i = 0; i < emptyImgs.length; i++) {
				if (!this.checkedImgs[i]) {
					this.showSrc[6 - emptyImgs.length + i].show = true
					break
				}
				this.showSrc[6 - emptyImgs.length + i].newurl = this.checkedImgs[i]
				this.showSrc[6 - emptyImgs.length + i].show = true
			}
			this.galleryShow = false
		},
		returnChange () {
			let imgFlag = this.showSrc.some(item => {
				return item.oldurl !== item.newurl
			})
			let videoFlag = this.videoOldUrl !== this.videoNewUrl
			return (imgFlag || videoFlag || this.sortFlag) && this.saveFlag
		},
		getInfo () {
			this.selectableNum = 6 - this.imgInfo.length
			if (this.imgInfo.length > 0) {
				this.imgInfo.forEach(item => {
					this.showSrc.forEach(i => {
						if (item.seqnum === +i.seqnum) {
							i.oldurl = item.url
							i.newurl = item.url
							i.id = item.id
							i.seqnum = '' + item.seqnum
						}
					})
				})
				let firstEmpty = this.showSrc.find(item => {
					return item.newurl === ''
				})
				this.showSrc.forEach(item => {
					item.show = item.newurl !== ''
					if (firstEmpty && firstEmpty.seqnum === item.seqnum) {
						item.show = true
					}
				})
			}
			let video = this.videoInfo
			if (video.length > 0) {
				this.videoNewUrl = video[0].url
				this.videoOldUrl = video[0].url
				this.videoId = video[0].id
			}
		},
		cancel () {
			this.$emit('cancel')
		},
		chooseImg (e) {
			this.oldShowSrc = this.showSrc.slice()
		},
		sortImg (e) {
			if (e.newIndex === e.oldIndex) {
				return false
			}
			if (this.oldShowSrc[e.oldIndex].newurl === '' || this.oldShowSrc[e.newIndex].newurl === '') {
				this.showSrc = this.oldShowSrc
			}
			if (e.newIndex !== e.oldIndex && this.oldShowSrc[e.oldIndex].newurl !== '' && this.oldShowSrc[e.newIndex].newurl !== '') {
				this.sortFlag = true
			}
		},
		updateImg (typeObj) {
			let showSrc = this.showSrc
			let temp
			if (typeObj.type === 'del') {
				this.selectableNum++
				let curIndex = this.showSrc.findIndex(item => {
					return item.seqnum === typeObj.seqnum
				})
				for (let i = curIndex; i < showSrc.length; i++) {
					if (showSrc[i + 1].newurl === '') {
						break
					}
					if (showSrc[i].newurl === '') {
						temp = showSrc[i]
						showSrc[i] = showSrc[i + 1]
						showSrc[i + 1] = temp
					}
				}
			}
			if (typeObj.type === 'add') {
				this.selectableNum--
			}
			let showImgArr = showSrc.filter(item => {
				if (item.newurl === '') {
					item.show = false
				}
				return item.newurl !== ''
			})
			if (showImgArr.length < 6) {
				this.showSrc[showImgArr.length].show = true
			}
		},
		preview (seqnum) {
			this.initialIndex = this.showSrc.findIndex(item => {
				return +item.seqnum === +seqnum
			})
			this.voucherImg = this.showSrc.filter(item => {
				return item.newurl !== ''
			})
			this.imgModel = true
		}
	}
}
</script>

<style lang="stylus" scoped>
.show-img-body {
	display: flex;
	flex: 1;
	flex-direction: column;
	.show-img-container {
		display: flex;
		flex: 1;
		flex-direction: column;
		text-align: left
		.img-des {
			color: #8A8A8A;
			padding-left: 15px;
		}
		p {
			font-size:15px
		}
	}
	.btn-box {
		height: 40px;
		display flex;
		justify-content center;
		margin-top: 10px;
		.el-button {
			width: 200px;
		}
	}
}
.preview-video-body {
	height: 400px;
	video {
		width: 500px;
		height: 400px;
		display: block;
		margin: auto;
		&:focus{
			outline:none
		}
	}
}
.online-img-container {
	p {
		line-height: 60px;
		border-top: 1px solid #eee
	}
	.img-container {
		display flex
		img {
			width: 80px;
			height: 80px;
			border-radius: 6px;
			margin-right: 10px;
		}
		margin-bottom: 10px;
	}
	.el-checkbox-group {
		display flex
		margin-bottom: 30px;
		.el-checkbox {
			width: 80px;
			display flex;
			flex-direction: column;
			align-items: center;
			margin-right: 10px;
			/deep/.el-checkbox__label {
				display: none;
			}
		}
	}
}
</style>
<style lang="stylus">
.el-dialog__body{
	padding: 10px 20px 20px 20px;
}
</style>
